import { render, staticRenderFns } from "./nuevoReferido.vue?vue&type=template&id=92ee98b2&scoped=true"
import script from "./nuevoReferido.vue?vue&type=script&lang=js"
export * from "./nuevoReferido.vue?vue&type=script&lang=js"
import style0 from "./nuevoReferido.vue?vue&type=style&index=0&id=92ee98b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ee98b2",
  null
  
)

export default component.exports